import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatIndividualSuite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxM0M4LjY1IDEzIDEwIDExLjY1IDEwIDEwQzEwIDguMzUgOC42NSA3IDcgN0M1LjM1IDcgNCA4LjM1IDQgMTBDNCAxMS42NSA1LjM1IDEzIDcgMTNaTTE5IDdIMTFWMTRIM1Y3SDFWMTdIMjNWMTFDMjMgOC43OSAyMS4yMSA3IDE5IDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatIndividualSuite = createIcon('AirlineSeatIndividualSuite', [
  [
    'path',
    {
      d: 'M7 13C8.65 13 10 11.65 10 10C10 8.35 8.65 7 7 7C5.35 7 4 8.35 4 10C4 11.65 5.35 13 7 13ZM19 7H11V14H3V7H1V17H23V11C23 8.79 21.21 7 19 7Z',
      key: 'dp9cn9',
    },
  ],
]);

export default AirlineSeatIndividualSuite;
